import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import cls from './sidebar.module.scss';

import AnalyticsHelper from '../../../helpers/AnalyticsHelper';
import SideBarEvent from './components/SideBarEvent';
import SideBarYacht from './components/SideBarYacht';
// import SideBarCaptain from './components/SideBarCaptain';
import IsShowModals from '../../../components/Modals/IsShowModal';
import ButtonHelpForm from '../../SendRequest/components/FormSend';

import eventAction from '../../../redux/actions/eventsBucket';

function Sidebar({ offer, user, event, slugEvent }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isModal, setIsModal] = useState(false);
  useEffect(() => {
    if (slugEvent && !event) {
      dispatch(eventAction.getEventPublic(slugEvent));
    }
  }, [dispatch, event, slugEvent]);

  let activeUser = {};
  if (offer && offer.yacht && offer.yacht.user) {
    activeUser = offer.yacht.user;
  } else if (user && user.name) {
    activeUser = user;
  }

  return (
    <section className={cls.sidebar}>
      <div className={cls.empty_wrap} />
      <div className={cls.sticky_wrap}>
        <SideBarEvent slugEvent={slugEvent} event={event} />
        {event && offer && offer.yacht && (
          <SideBarYacht event={event} yacht={offer.yacht} />
        )}
        {/* <SideBarCaptain offer={offer} event={event} activeUser={activeUser} /> */}
        {Object.keys(activeUser).length > 0 ? (
          <div className={cls.offerBox_captain}>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              style={{ width: '100%' }}
              onClick={() => {
                AnalyticsHelper.sendStaticEvent('purchaseSidebarContactClick');
                setIsModal(true);
              }}
            >
              {t('purchase.contact')}
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
      <IsShowModals
        deed={isModal}
        closeDeed={() => setIsModal(false)}
        modalContent={
          <ButtonHelpForm
            setFormModal={setIsModal}
            contact={{
              event: event && event.slug,
              yacht: offer.yacht && offer.yacht.slug,
              user: offer.user,
            }}
          />
        }
        title={t('purchase.contactTitle')}
      />
    </section>
  );
}

Sidebar.propTypes = {
  offer: PropTypes.shape(),
  user: PropTypes.shape(),
  event: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }).isRequired,
  slugEvent: PropTypes.string,
};

Sidebar.defaultProps = {
  slugEvent: null,
  user: {},
  offer: {},
};

export default Sidebar;
